import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import Update1FormMeta from './PromotorFormMeta';
import BankPromotorMainFormUI from '@Modules/admin/basicSettings/components/formsUI/bank/BankPromotorMainFormUI';

export default function PromotorMainFormHandler() {
  const toast = useToast();
  const { isLoading } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'effectué avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const onSubmit = (payload: any) => {
    console.log('payload: ', payload);
  };

  return (
    <>
      <BankPromotorMainFormUI
        isLoading={isLoading}
        meta={Update1FormMeta}
        onSubmit={onSubmit}
      />
    </>
  );
}
